import React from 'react';

import RecursionListItem from '../recursionListItem';

import * as Styled from './styled';

const RecursionList = (props) => {
  const {
    fieldValue,
    search,
    arr,
    formik,
    onShow,
    isRenderList = true,
    currentMeasures,
    expandedKeys,
    setExpandedKeys,
  } = props;

  if (!isRenderList) {
    return null;
  }

  if (!arr?.length) {
    return null;
  }

  return (
    <Styled.UL>
      {arr?.map((el, index) => {
        return (
          <RecursionListItem
            key={index}
            fieldValue={fieldValue}
            search={search}
            el={el}
            onShow={onShow}
            formik={formik}
            currentMeasures={currentMeasures}
            expandedKeys={expandedKeys}
            setExpandedKeys={setExpandedKeys}
          />
        );
      })}
    </Styled.UL>
  );
};

export default RecursionList;
